// Generates quotable, per-property Q&A copy so AI answer engines cite the
// specific listing (not just the homepage). Tailored from each property's data.
export function propertyFaq(p) {
  const isWilton = /Wilton Manors/i.test(p.location);
  const petFriendly = (p.amenities || []).some((a) => /pet/i.test(a));
  const hasPool = (p.amenities || []).some((a) => /pool/i.test(a));
  const hasEv = (p.amenities || []).some((a) => /EV charger/i.test(a));
  const plural = (n) => (n > 1 ? "s" : "");
  const faqs = [];

  if (isWilton) {
    faqs.push({
      q: `Can you walk to Wilton Drive from ${p.shortName}?`,
      a: `Yes. ${p.name} sits in the heart of Wilton Manors, a short walk from Wilton Drive's bars, restaurants, cafés and nightlife — leave the car and stroll to dinner or a drink in minutes, then come home to a quiet retreat.`,
    });
  } else {
    faqs.push({
      q: `How close is ${p.shortName} to the beach and Wilton Drive?`,
      a: `${p.name} is in Fort Lauderdale, roughly a 10-minute drive from both Fort Lauderdale Beach and the nightlife of Wilton Drive in Wilton Manors — central to everything, yet a private, quiet retreat of its own.`,
    });
  }

  if (petFriendly) {
    faqs.push({
      q: `Is ${p.shortName} pet-friendly?`,
      a: `Yes — ${p.name} is pet-friendly, just like every Double Rainbow Suites home. Dogs and cats are always welcome, no restrictions. A small pet fee applies per pet, per stay and varies a little by home — the exact amount is shown at checkout before you book, never on arrival. Simply add your pet to the reservation and the home will be ready to welcome the whole family.`,
    });
  }

  if (hasEv) {
    faqs.push({
      q: `Does ${p.shortName} have EV charging?`,
      a: `Yes — ${p.name} has a Level 2 EV charger on-site, free for guests to use throughout their stay. Plug in overnight and wake up to a full charge.`,
    });
  }

  if (hasPool) {
    faqs.push({
      q: `Does ${p.shortName} have a private pool?`,
      a: `Yes. ${p.name} features a heated private pool, so you can swim in complete privacy throughout your stay — a favorite feature for families and groups.`,
    });
  } else {
    faqs.push({
      q: `How many guests does ${p.shortName} sleep?`,
      a: `${p.name} comfortably sleeps ${p.guests} guest${plural(p.guests)} across ${p.bedrooms} bedroom${plural(p.bedrooms)} and ${p.bathrooms} bathroom${plural(p.bathrooms)}, with king beds for a great night's sleep.`,
    });
  }

  return faqs;
}
